import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./Redux/store";
import "antd/dist/antd.min.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./Stylesheet/global.scss";
import "rc-time-picker/assets/index.css";
import { AppProvider } from "./Store/AppContext";

ReactDOM.render(
  <AppProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </AppProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
